import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-06fa77fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "tag_content_wrap"
}
const _hoisted_2 = {
  key: 1,
  class: "tag_content_wrap zero_item"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import SimpleCheckbox from '@/components/atoms/SimpleCheckbox'
import { CameratagWithCameras } from '@/@types/typescript-axios'
import { computed, withDefaults } from 'vue'

type tagsStatusType = {
  [key: string]: { checked: boolean; indeterminate: boolean }
} | null

type PropsType = {
  tags?: CameratagWithCameras[] | null
  tagsStatus?: tagsStatusType
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TagList',
  props: {
    tags: { default: null },
    tagsStatus: { default: null }
  },
  emits: ["update:tagsStatus"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:tagsStatus', value: tagsStatusType): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { tags: CameratagWithCameras[] | null, tagsStatus: tagsStatusType };





const status = computed({
  get: () => props.tagsStatus,
  set: (value) => {
    emit('update:tagsStatus', value)
  },
})

const isZeroItem = computed<boolean>(() => !props.tags || props.tags.length === 0)

return (_ctx: any,_cache: any) => {
  return (!_unref(isZeroItem))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tags, (tag) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "tag_content",
            key: tag.tag_code
          }, [
            _createVNode(_unref(SimpleCheckbox), {
              label: tag.tag_name,
              modelValue: _unref(status)[tag.tag_code].checked,
              "onUpdate:modelValue": ($event: any) => ((_unref(status)[tag.tag_code].checked) = $event),
              indeterminate: _unref(status)[tag.tag_code].indeterminate,
              "onUpdate:indeterminate": ($event: any) => ((_unref(status)[tag.tag_code].indeterminate) = $event)
            }, null, 8, ["label", "modelValue", "onUpdate:modelValue", "indeterminate", "onUpdate:indeterminate"])
          ]))
        }), 128))
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createTextVNode(" ※" + _toDisplayString(_ctx.$t('tag_list.there_is_no_tag')), 1),
        _hoisted_3,
        _createTextVNode(_toDisplayString(_ctx.$t('tag_list.tag_from')), 1)
      ]))
}
}

})